import React from 'react';
import { bonuses, bonusesTotalValue } from '../data/content';
export function Bonuses() {
  return <section className="bg-night-panel" data-id="element-18" data-mp="pkhg03f3hqhl">
      <div className="mx-auto max-w-content px-6 py-16 lg:py-24" data-id="element-19" data-mp="pjg1foyvelv4">
        <div className="mx-auto max-w-2xl text-center" data-id="element-20" data-mp="avv1u517f4ry">
          <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" style={{
          fontSize: "32px"
        }} data-id="element-21" data-mp="at8ua5ebcp9q">
            🎁 4 Bonos de regalo
          </h2>
          <p className="mt-3 font-sans text-sm font-semibold uppercase tracking-[0.16em] text-gold-soft" data-id="element-22" data-mp="1wrhkxqawjbv">
            Siempre incluidos
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-23" data-mp="3o2wq7bh7vtk2">
          {bonuses.map((bonus, index) => <article key={bonus.title} className={`flex flex-col gap-6 rounded-2xl border border-gold-soft/30 bg-night p-6 sm:flex-row lg:p-8 ${index === bonuses.length - 1 && bonuses.length % 2 === 1 ? 'md:col-span-2' : ''}`} data-id="element-24" data-mp="3t1himoq898xy" data-mpi={index}>
              <img src={bonus.image} alt={`Portada de ${bonus.title}`} className="mx-auto w-40 flex-none rounded-xl object-contain shadow-[0_18px_28px_rgba(0,0,0,0.45)] sm:mx-0 sm:w-36 sm:self-start" data-id="element-25" data-mp="1r78tfe5c4avx" />

              <div className="flex flex-1 flex-col" data-id="element-26" data-mp="3dd8yz2knl3t4">
                
                <span className="mt-2 font-sans text-xs font-semibold uppercase tracking-[0.14em] text-gold" data-id="element-27" data-mp="3r5gkfy6hl8ci">
                  🎁 {bonus.label}
                </span>
                <h3 className="mt-2 font-display text-2xl font-semibold leading-snug text-parchment" data-id="element-28" data-mp="2zf2b8f9f4k76">
                  {bonus.title}
                </h3>
                <p className="mt-1 font-sans text-sm font-medium text-parchment/55" data-id="element-29" data-mp="2uik97n5h2zyj">
                  {bonus.subtitle}
                </p>
                <p className="mt-3 font-sans text-base leading-relaxed text-parchment/75" data-id="element-30" data-mp="33gnviloa80re">
                  {bonus.description}
                </p>

                <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-31" data-mp="no6pvjqr18nt">
                  <span className="font-sans text-base text-parchment/45 line-through" data-id="element-32" data-mp="ipwv3a8xsa2q">
                    {bonus.value}
                  </span>
                  <span className="rounded-full bg-gold-soft px-3 py-1 font-sans text-sm font-bold uppercase tracking-wide text-night" data-id="element-33" data-mp="3cl958rrnj9qx">
                    Gratis
                  </span>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-xl rounded-2xl border border-gold-soft/40 bg-gold/10 p-6 text-center" data-id="element-34" data-mp="3qhe7w3gi5vrk">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-gold-soft" data-id="element-35" data-mp="2tu9m476u8u5k">
            Valor total de los bonos
          </p>
          <p className="mt-3 flex flex-wrap items-center justify-center gap-3" data-id="element-36" data-mp="32sleadncs004">
            <span className="font-display text-2xl text-parchment/45 line-through" data-id="element-37" data-mp="37jjtf9wlus1s">
              {bonusesTotalValue}
            </span>
            <span className="font-display text-2xl font-semibold text-gold-soft" data-id="element-38" data-mp="2a3eap091kk80">
              → Gratis con tu GPS Bíblico
            </span>
          </p>
        </div>
      </div>
    </section>;
}